module.exports = __webpack_public_path__ + "img/the-netherlands-cerebrovascular-disease-female.1a10ee79.png";